import React, { useState, useEffect } from 'react';

export const useCustomEvent = (eventName: any) => {
    const [evtCounter, setEvtCounter] = useState(0);

    useEffect(() => {
        function handleEventChange() {
            setEvtCounter((prev: number) => prev + 1);
        }

        window.addEventListener(eventName, handleEventChange);
        return () => {
            window.removeEventListener(eventName, handleEventChange);
        };
    },[]);

    return evtCounter;
}